import type { RetryOptions } from 'common/types';

export type MergeRetryOptionsParams = {
  baseRetryOptions: RetryOptions;
  retryOptionsToMerge?: Partial<RetryOptions>;
};

export const mergeRetryOptions = ({
  baseRetryOptions,
  retryOptionsToMerge,
}: MergeRetryOptionsParams): RetryOptions => {
  return { ...baseRetryOptions, ...retryOptionsToMerge };
};
